import React from 'react';
import './App.css';
import AWSCostEstimationDashboard from './components/AWSCostEstimationDashboard';

function App() {
  return (
    <div className="App">
      <AWSCostEstimationDashboard />
    </div>
  );
}

export default App;